// NOTE THIS IS LEGACY, WE SHOULD REMOVE THIS AND REPLACE WITH featureFlags

// This is used to hide features on the client. Currently used for module level.
const actionTypes = {
  SetDiscover: 'flags/SET_DISCOVER',
  SetEngage: 'flags/SET_ENGAGE',
}

// We are disabling engage by default. Change this as needed in the future
const initialState = {
  discover: true,
  engage: false,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetDiscover:
      return { ...state, discover: action.payload.discover }
    case actionTypes.SetEngage:
      return { ...state, engage: action.payload.engage }
    default:
      return state
  }
}

export const actions = {
  setDiscover: (discover) => ({
    type: actionTypes.SetDiscover,
    payload: { discover },
  }),
  setEngage: (engage) => ({ type: actionTypes.SetEngage, payload: { engage } }),
}
